module.exports = __webpack_public_path__ + "img/g2.af58ecb8.png";